import React from 'react';
import { useAppStore } from '../../../../store/useAppStore';
import AssetPicker from '../../../Assets/AssetPicker';

export const FileUploaderForm = ({ component, onUpdate }) => {
  const { appName } = useAppStore();

  const handleChange = (field, value) => {
    onUpdate(component.id, {
      specificAttrs: { ...component.specificAttrs, [field]: value }
    });
  };

  const { specificAttrs } = component;

  return (
    <div style={{ display: 'grid', gap: '12px' }}>
      {/* Asset Picker for selecting from library or uploading */}
      {appName && (
        <AssetPicker
          appId={appName}
          value={specificAttrs.defaultFile || ''}
          onChange={(url) => handleChange('defaultFile', url)}
          label="Default File (Optional)"
          fileType="document"
          placeholder="Select a document from library..."
          showPreview={true}
        />
      )}
      
      <div>
        <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
          Label
        </label>
        <input
          type="text"
          value={specificAttrs.label || ''}
          onChange={(e) => handleChange('label', e.target.value)}
          placeholder="Upload File"
          style={{
            width: '100%',
            padding: '6px 10px',
            fontSize: '13px',
            border: '1px solid #D1D5DB',
            borderRadius: '6px'
          }}
        />
      </div>
      
      <div>
        <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
          Accepted File Types
        </label>
        <input
          type="text"
          value={specificAttrs.accept || ''}
          onChange={(e) => handleChange('accept', e.target.value)}
          placeholder=".pdf,.doc,.docx,.xls,.xlsx"
          style={{
            width: '100%',
            padding: '6px 10px',
            fontSize: '13px',
            border: '1px solid #D1D5DB',
            borderRadius: '6px'
          }}
        />
        <div style={{ fontSize: '11px', color: '#6B7280', marginTop: '4px' }}>
          Comma-separated file extensions (e.g., .pdf,.doc,.xls)
        </div>
      </div>
      
      <div>
        <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
          Max File Size (MB)
        </label>
        <input
          type="number"
          value={specificAttrs.maxSize || 10}
          onChange={(e) => handleChange('maxSize', parseInt(e.target.value) || 10)}
          min="1"
          max="50"
          style={{
            width: '100%',
            padding: '6px 10px',
            fontSize: '13px',
            border: '1px solid #D1D5DB',
            borderRadius: '6px'
          }}
        />
      </div>
      
      <div>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={specificAttrs.multiple || false}
            onChange={(e) => handleChange('multiple', e.target.checked)}
          />
          <span style={{ fontSize: '12px', fontWeight: '500', color: '#4B5563' }}>
            Allow Multiple Files
          </span>
        </label>
      </div>
      
      <div>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={specificAttrs.required || false}
            onChange={(e) => handleChange('required', e.target.checked)}
          />
          <span style={{ fontSize: '12px', fontWeight: '500', color: '#4B5563' }}>
            Required Field
          </span>
        </label>
      </div>
    </div>
  );
};









